import { type ActionType, createReducer } from 'typesafe-actions';
import { deleteContent, updateContent } from '../content/actions';
import {
  type AssetsActions,
  deleteSelected,
  deleteSelectedPending,
  setAssetLocale,
  toggleAllFulfilled,
  toggleAssetEditing,
  toggleAssetSelection,
  toggleSortMenuOpen
} from './actions';

export type AssetsState = {
  selectAll: boolean;
  editingId?: string;
  editingLocale?: string;
  selected: string[];
  sortMenuOpen: boolean;
};

export const initialAssetsState: AssetsState = {
  selectAll: false,
  selected: [],
  sortMenuOpen: false
};

function toggle(selected: string[], value: string): string[] {
  return selected.includes(value) ? selected.filter((id) => id !== value) : selected.concat(value);
}

export type HandledAssetsActions = AssetsActions | ActionType<typeof updateContent> | ActionType<typeof deleteContent>;

export default createReducer<AssetsState, HandledAssetsActions>(initialAssetsState)
  .handleAction(toggleAssetSelection, (state, { payload }) => ({
    ...state,
    selected: toggle(state.selected, payload)
  }))
  .handleAction(toggleAllFulfilled, (state, { payload }) => {
    const selectAll = !state.selectAll;
    return {
      ...state,
      selectAll,
      selected: selectAll ? payload : []
    };
  })
  .handleAction(toggleAssetEditing, (state, { payload }) => ({
    ...state,
    editingLocale: undefined,
    editingId: state.editingId === payload ? undefined : payload
  }))
  .handleAction(deleteSelected, (state) => {
    const { selected, editingId } = state;
    return {
      ...state,
      editingId: editingId && selected.includes(editingId) ? undefined : editingId
    };
  })
  .handleAction(deleteSelectedPending, (state) => {
    return { ...state, selected: [] };
  })
  .handleAction(updateContent.pending, (state, { meta }) => {
    const { editingId } = state;
    return meta.contentId === editingId ? { ...state, editingId: undefined } : state;
  })
  .handleAction(deleteContent.pending, (state, { meta }) => {
    const { editingId } = state;
    return meta.contentId === editingId ? { ...state, editingId: undefined } : state;
  })
  .handleAction(toggleSortMenuOpen, (state) => {
    return { ...state, sortMenuOpen: !state.sortMenuOpen };
  })
  .handleAction(setAssetLocale, (state, { payload }) => ({
    ...state,
    editingLocale: payload
  }));
